import React from 'react';
import { useSearchParams } from 'react-router-dom';
import WizardForm from '../components/WizardForm';

const WizardPage = () => {
  const [searchParams] = useSearchParams();
  
  // Parse URL parameters for pre-filling wizard
  const getUrlParams = () => {
    const params = {};
    
    // Parse all URL parameters
    if (searchParams.get('propertytype')) params.propertyType = searchParams.get('propertytype');
    if (searchParams.get('price')) params.utgangspris = parseFloat(searchParams.get('price'));
    if (searchParams.get('taxvalue')) params.taxeringsvarde = parseFloat(searchParams.get('taxvalue'));
    if (searchParams.get('mortgagecert')) params.pantbrev = parseFloat(searchParams.get('mortgagecert'));
    if (searchParams.get('monthlycost')) params.monthlyCost = parseFloat(searchParams.get('monthlycost'));
    // Backward compatibility for old URL parameters
    if (searchParams.get('operating')) params.driftkostnad = parseFloat(searchParams.get('operating'));
    if (searchParams.get('avgift')) params.avgift = parseFloat(searchParams.get('avgift'));
    if (searchParams.get('downpayment')) params.egenInsats = searchParams.get('downpayment');
    if (searchParams.get('mortgagerate')) params.mortgageInterestRate = parseFloat(searchParams.get('mortgagerate'));
    if (searchParams.get('amortization')) params.amortering = searchParams.get('amortization');
    
    return params;
  };


  return (
    <WizardForm 
      initialData={getUrlParams()}
    />
  );
};

export default WizardPage;